export default "__VITE_ASSET__2LRXTcw9__"